import { render, staticRenderFns } from "./permanentTextFieldProps.vue?vue&type=template&id=1c5f45c4&scoped=true&"
import script from "./permanentTextFieldProps.vue?vue&type=script&lang=js&"
export * from "./permanentTextFieldProps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5f45c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib'
import { VExpandTransition } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VCheckbox,VExpandTransition,VTextField,VTextarea})
